import React, { Component } from "react";
import styles from "./Login.module.css";
import { LockOutlined, UserOutlined , DashboardOutlined } from "@ant-design/icons";
import { Alert, Button, Checkbox, Form, Input } from "antd";
import * as actions from "../../store/actions/action";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import LoginSVG from './img/LoginSVG.svg';
import Logo from "../../Components/Logo/Logo";
import { PageHeader } from "@ant-design/pro-components";

class Login extends Component {

  onFinish = (values) => {
    console.log("Received values of form: ", values);
    this.props.onSignIn(values.username , values.password)
    
  };
  render() {
    return (
      <div className={styles.Login}>
        {this.props.token ? <Navigate to="/" /> : null}
        
        <div className={styles.LoginFormContainer}>
          
          <div className={styles.LoginForm}>
          <PageHeader
          className={styles.PageHeader}
          title="سامانه مدیریت زبان آموزان"
          avatar={{icon : <DashboardOutlined />}}
          subTitle="| ورود به سیستم"
           />
          <Form
            name="login"
            initialValues={{
              remember: true,
            }}
            onFinish={this.onFinish}
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "لطفا نام کاربری خود را وارد کنید!",
                },
              ]}
            >
              <Input
                size="large"
                prefix={<UserOutlined className={styles.InputIcon} />}
                placeholder="نام کاربری"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "لطفا رمز عبور خود را وارد کنید!",
                },
              ]}
            >
              <Input
                prefix={<LockOutlined className={styles.InputIcon} />}
                type="password"
                placeholder="رمز عبور"
                size="large"

              />
            </Form.Item>
            <Form.Item>
              <div style={{display : "flex" , alignItems : "center" , justifyContent: "space-between"}}>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>من را به خاطر بسپار</Checkbox>
              </Form.Item>

              <a className="login-form-forgot" href="/">
                رمزم را فراموش کردم
              </a>
              </div>
              
            </Form.Item>

            <Form.Item>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                className="login-form-button"
                block
                loading={this.props.loading}
              >
                ورود
              </Button>
            </Form.Item>
          </Form>
          {this.props.error ? <Alert type="error" showIcon afterClose={this.props.ClearError} closable message="خطا در ورود" description="نام کاربری یا رمز عبور اشتباه است!" /> : null}
          </div>
        </div>
        <div className={styles.LoginLeftSide}>
          <Logo className={styles.LoginLogo} />
          <img className={styles.LoginImg} src={LoginSVG} alt='Login' />
          {/* <h2>پپتاک، آموزشگاه اختصاصی زبان!</h2> */}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    token: state.token,
    loading : state.loading,
    error : state.error
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onSignIn: (userName , password) => dispatch(actions.SignInStart(userName , password)),
    ClearError : ()=> dispatch(actions.ClearError()),
    
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
